import React from 'react';

import {Chat, Poll, Questions, Reactions, RemoteControl, Stream} from 'Components/MainStage';

import {translation} from 'Services/TranslationHelpers';

export default ({ currentSession, currentPoll }) => (
    <React.Fragment>
        {!currentSession &&
            <div className="my-8 text-center text-xl font-bold">
                {translation('main_stage_frontend', 'no_sessions_live')}
            </div>
        }

        {currentSession && currentSession.outage_message &&
            <div className="my-8 text-center text-xl font-bold">
                {currentSession.outage_message}
            </div>
        }

        {currentSession && !currentSession.outage_message &&
            <div>
                <div className="grid grid-cols-1 md:grid-cols-3 md:gap-8">
                    <div className={`${currentSession?.chat ? 'col-span-2' : 'col-span-3'}`}>
                        {currentSession?.reactions === true && (
                            <Reactions
                                side="right"
                                sessionId={currentSession.id}
                            >
                                <Stream stream={currentSession}/>
                            </Reactions>
                        )}

                        {currentSession?.reactions === false && (
                            <Stream stream={currentSession}/>
                        )}
                    </div>

                    {currentSession?.chat && (
                        <div className="mt-8 md:mt-0">
                            <Chat
                                sessionId={currentSession.id}
                            />
                        </div>
                    )}
                </div>

                {currentSession?.questions && (
                    <div className="w-full text-center mt-8">
                        <Questions
                            sessionId={currentSession.id}
                        />
                    </div>
                )}

                {currentSession?.remote_control && (
                    <div className="w-full text-center mt-8">
                        <RemoteControl
                            sessionId={currentSession.id}
                        />
                    </div>
                )}

                {currentSession?.polls_enabled && (
                    <div className="w-full mt-4">
                        <div className="w-1/2 mx-auto">
                            <Poll
                                poll={currentPoll}
                                sessionId={currentSession.id}
                            />
                        </div>
                    </div>
                )}
            </div>
        }
    </React.Fragment>
);
